import * as services from '.';

export const allServices = [
    services.DataService,
    services.HttpCancelService,
    services.LoaderHandlerService,
    services.ServicecallService,
    services.SharedService,
    services.SubmitButtonClickService,
    services.ToggleSidebarService,

    services.AuthGuardService,
    services.AuthserviceService,
    services.HttpGuardService,
    services.TokenGuardService,
    services.GeneralService,
    services.ThemeService
];
